export default __webpack_public_path__ + "static/media/s.e7058f29.png";